import "angular-translate";

import type { IAlarmCentralSite, IResponseWithLoading, ISite } from "App/Modules/Models";
import { AlarmCentralType } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class AlarmCentralInformationComponentController {
    public static $inject: string[] = ["$translate", "mmModalService"];

    public site: IResponseWithLoading<ISite>;

    public siteAlarmCentrals: IAlarmCentralSite[];

    public isLoading: boolean;

    public subCaption: string;

    constructor(
        private readonly $translate: ng.translate.ITranslateService,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        if (this.site.data) {
            this.updateSubCaption();
            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }

    public editAlarmCentrals() {
        this.modalService.open<ISite, void>("mmEditSiteAlarmCentrals", this.site.data).subscribe(
            (editResponse) => {
                this.site.data = editResponse;
                this.updateSubCaption();
            },
            (reason) => reason,
        );
    }

    private updateSubCaption() {
        this.siteAlarmCentrals = this.site.data.alarmCentrals.filter(
            (acs) => acs.alarmCentralType !== AlarmCentralType.Tertiary,
        );
        if (this.siteAlarmCentrals.length > 0) {
            this.subCaption = this.siteAlarmCentrals.map((ac) => ac.alarmCentral.name).join(", ");
        } else {
            this.$translate("Entities.AlarmCentral.NoAlarmCentrals").then((translation) => {
                this.subCaption = translation;
            });
        }
    }
}
